import type { CommentsItemKind } from '../../types'

interface Noun {
  one: string
  many: string
}

const NOUNS: Record<CommentsItemKind, Noun> = {
  thread: { one: 'reply', many: 'replies' },
  block: { one: 'comment', many: 'comments' },
  page: { one: 'comment', many: 'comments' },
}

export const getRepliesLabel = (
  count: number,
  kind: CommentsItemKind = 'thread'
) => {
  if (count === 0) {
    return null
  }

  const { one, many } = NOUNS[kind]

  return count === 1 ? `1 ${one}` : `${count} ${many}`
}
